<template>
  <component :is="is" class="result-card">
    <div class="result-card-details">
      <span
        v-if="subtitle"
        class="result-card-subtitle text-caption-caps text-gradient-primary"
      >{{ subtitle }}</span>
      <h4 class="result-card-title new-heading-4 wrap-word">{{ title }}</h4>
      <p
        v-if="description"
        class="result-card-description text-body-small mt-0"
      >{{ description }}</p>
    </div>
    <div class="result-card-image">
      <div class="media-scaled media-16-by-9">
        <img v-if="imageSource" :src="imageSource" :alt="imageAlt" class="object-fit-cover" loading="lazy" />
      </div>
    </div>
  </component>
</template>

<script>
export default {
  props: {
    is: {
      type: String,
      default: 'li',
    },
    subtitle: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
    imageSource: {
      type: String,
      required: false,
    },
    imageAlt: {
      type: String,
      required: false,
    },
  },
};
</script>
